import { PersistQueryClientProvider } from "@tanstack/react-query-persist-client";
import "./App.css";
import AppRoutes from "./routes/AppRoutes";
import { BrowserRouter as Router } from "react-router-dom";
import { ApplicationProvider } from "./services/context/ApplicationStateContext";
import {
  handlePersistSuccess,
  persistOptions,
  queryClient,
} from "./services/query/persistedQueryClient";

function App() {
  return (
    <PersistQueryClientProvider
      client={queryClient}
      persistOptions={persistOptions}
      onSuccess={handlePersistSuccess}
    >
      <ApplicationProvider>
        <Router>
          <AppRoutes />
        </Router>
      </ApplicationProvider>
    </PersistQueryClientProvider>
  );
}

export default App;
